<template>
  <div class="h-dvh w-dvw bg-primary-50 flex items-center justify-center">
    <div class="max-w-md text-center px-4">
      <LogoRvezy class="mb-4 mx-auto" />
      <p class="text-xl">
        {{ t('content') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

useSeoHeadTags({
  title: computed(() => t('metaTitle')),
  description: computed(() => ''),
})
</script>

<i18n lang="json">
{
  "en": {
    "metaTitle": "RVezy - Offline for maintenance, check back later",
    "content": "We’re currently performing maintenance on our site, please check back later!"
  },
  "fr": {
    "metaTitle": "RVezy - Hors ligne pour maintenance, revenez plus tard",
    "content": "Nous effectuons actuellement une maintenance sur notre site, veuillez revenir plus tard !"
  }
}
</i18n>
